import { ref } from 'vue'

/**
 * Pont entre le client API et la modale de **step-up** : le middleware demande une
 * montée d'assurance et attend la réponse de l'utilisateur ; la modale la règle.
 * Plusieurs refus simultanés partagent une seule modale et une seule réponse.
 */
export interface StepUpRequest {
  minLoa: number
}

const pending = ref<StepUpRequest | null>(null)
let inflight: Promise<boolean> | null = null
let settle: ((upgraded: boolean) => void) | null = null

export function requestStepUp(minLoa: number): Promise<boolean> {
  if (inflight) return inflight
  inflight = new Promise<boolean>((resolve) => {
    settle = resolve
    pending.value = { minLoa }
  })
  return inflight
}

export function settleStepUp(upgraded: boolean): void {
  const resolve = settle
  settle = null
  inflight = null
  pending.value = null
  resolve?.(upgraded)
}

export function useStepUp() {
  return { pending }
}
